function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { GRID_ROOT_GROUP_ID } from '@mui/x-data-grid';
import { buildRootGroup } from '@mui/x-data-grid/internals';
import { insertDataRowInTree } from "./insertDataRowInTree.js";
/**
 * Transform a list of rows into a tree structure where each row references its parent and children.
 */ export var createRowTree = function(params) {
    var dataRowIds = [];
    var tree = _define_property({}, GRID_ROOT_GROUP_ID, buildRootGroup());
    var treeDepths = {};
    var groupsToFetch = new Set();
    for(var i = 0; i < params.nodes.length; i += 1){
        var node = params.nodes[i];
        dataRowIds.push(node.id);
        insertDataRowInTree({
            tree: tree,
            previousTree: params.previousTree,
            id: node.id,
            path: node.path,
            serverChildrenCount: node.serverChildrenCount,
            onDuplicatePath: params.onDuplicatePath,
            treeDepths: treeDepths,
            isGroupExpandedByDefault: params.isGroupExpandedByDefault,
            defaultGroupingExpansionDepth: params.defaultGroupingExpansionDepth,
            groupsToFetch: groupsToFetch
        });
    }
    return {
        tree: tree,
        treeDepths: treeDepths,
        groupingName: params.groupingName,
        dataRowIds: dataRowIds,
        groupsToFetch: Array.from(groupsToFetch)
    };
};
